(function () {
  'use strict';
  const root = document.querySelector('[data-st-route]');
  if (!root) return;
  const en = root.closest('[data-language]').dataset.language === 'en';
  const text = (english, indonesian) => en ? english : indonesian;
  const data = JSON.parse(root.querySelector('[data-route-data]').textContent);
  const points = data.points, distances = data.distances, total = distances[distances.length - 1];
  const status = root.querySelector('[data-route-status]');
  const slider = root.querySelector('[data-route-progress]');
  const play = root.querySelector('[data-route-play]');
  const view = root.querySelector('[data-route-view]');
  const position = root.querySelector('[data-route-position]');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let map, cursor, loaded = false, running = false, frame = 0, progress = 0, lastTime = 0, is3D = true;
  const feature = coordinates => ({type: 'Feature', properties: {}, geometry: {type: 'LineString', coordinates}});
  const line = feature(points.map(p => p.slice(0, 2)));
  function sample(metres) {
    const target = Math.max(0, Math.min(total, metres));
    let i = 1;
    while (i < distances.length - 1 && distances[i] < target) i++;
    const fraction = (target - distances[i - 1]) / (distances[i] - distances[i - 1] || 1);
    return {index: i, point: points[i - 1].map((v, axis) => v + (points[i][axis] - v) * fraction)};
  }
  function showProgress(metres) {
    progress = Math.max(0, Math.min(total, metres));
    const {index, point} = sample(progress);
    slider.value = Math.round(progress);
    const label = `${(progress / 1000).toLocaleString(en ? 'en' : 'id', {minimumFractionDigits: 2, maximumFractionDigits: 2})} km · ${Math.round(point[2])} m`;
    position.textContent = label;
    slider.setAttribute('aria-valuetext', label);
    const x = 40 + progress / total * 920;
    const y = 130 - (point[2] - data.minElevation) / (data.maxElevation - data.minElevation) * 100;
    const guide = root.querySelector('[data-route-profile-line]');
    guide.setAttribute('x1', x); guide.setAttribute('x2', x);
    const dot = root.querySelector('[data-route-profile-dot]');
    dot.setAttribute('cx', x); dot.setAttribute('cy', y);
    if (!loaded) return;
    cursor.setLngLat(point.slice(0, 2));
    map.getSource('st-travelled').setData(feature([...points.slice(0, index).map(p => p.slice(0, 2)), point.slice(0, 2)]));
  }
  function pause() {
    running = false;
    cancelAnimationFrame(frame);
    play.textContent = text('Play route', 'Putar animasi rute');
    play.setAttribute('aria-pressed', 'false');
  }
  function tick(now) {
    if (!running) return;
    const delta = Math.min(now - lastTime, 100);
    lastTime = now;
    showProgress(progress + delta / 45000 * total);
    if (progress >= total) { pause(); return; }
    frame = requestAnimationFrame(tick);
  }
  slider.disabled = false;
  slider.addEventListener('input', () => { pause(); showProgress(Number(slider.value)); });
  play.addEventListener('click', () => {
    if (running) { pause(); return; }
    if (progress >= total) showProgress(0);
    running = true;
    play.textContent = text('Pause', 'Jeda');
    play.setAttribute('aria-pressed', 'true');
    lastTime = performance.now();
    frame = requestAnimationFrame(tick);
  });
  function fit(duration) {
    map.fitBounds(data.bounds, {padding: {top: 80, bottom: 60, left: 50, right: 50}, pitch: is3D ? 50 : 0,
      bearing: is3D ? -20 : 0, maxZoom: 14.7, duration: reducedMotion.matches ? 0 : duration});
  }
  view.addEventListener('click', () => {
    pause(); is3D = !is3D;
    map.setTerrain(is3D ? {source: 'st-terrain', exaggeration: 1} : null);
    view.setAttribute('aria-pressed', String(is3D));
    fit(700);
  });
  root.querySelector('[data-route-reset]').addEventListener('click', () => { pause(); showProgress(0); fit(700); });
  document.addEventListener('visibilitychange', () => { if (document.hidden) pause(); });
  function unavailable() {
    pause();
    loaded = false;
    root.querySelector('[data-route-toolbar]').hidden = true;
    root.querySelector('[data-route-fallback]').hidden = false;
    status.textContent = text('Interactive map unavailable. The route outline, elevation profile and GPX download are still available.',
      'Peta interaktif belum bisa dibuka. Kamu masih bisa melihat rute dan profil elevasi, serta mengunduh file GPX.');
    if (map) { map.remove(); map = null; }
  }
  async function loadMap() {
    try {
      const css = document.createElement('link');
      css.rel = 'stylesheet'; css.href = root.dataset.mapCss; document.head.appendChild(css);
      await new Promise((resolve, reject) => {
        if (window.maplibregl) { resolve(); return; }
        const script = document.createElement('script');
        script.src = root.dataset.mapScript;
        script.onload = resolve; script.onerror = reject; document.head.appendChild(script);
      });
      const gl = window.maplibregl;
      map = new gl.Map({container: root.querySelector('[data-route-map]'),
        style: 'https://tiles.openfreemap.org/styles/liberty',
        center: [(data.bounds[0][0] + data.bounds[1][0]) / 2, (data.bounds[0][1] + data.bounds[1][1]) / 2],
        zoom: 13.6, pitch: 50, bearing: -20, maxZoom: 17, minZoom: 10,
        cooperativeGestures: true, attributionControl: false,
        locale: {'NavigationControl.ZoomIn': text('Zoom in', 'Perbesar'),
          'NavigationControl.ZoomOut': text('Zoom out', 'Perkecil'),
          'NavigationControl.ResetBearing': text('Reset north', 'Arah utara'),
          'FullscreenControl.Enter': text('Full screen', 'Layar penuh'),
          'FullscreenControl.Exit': text('Exit full screen', 'Tutup layar penuh')}});
      map.addControl(new gl.NavigationControl({visualizePitch: true}), 'top-right');
      map.addControl(new gl.FullscreenControl(), 'top-right');
      map.addControl(new gl.AttributionControl({compact: true}), 'bottom-right');
      map.addControl(new gl.ScaleControl({maxWidth: 90, unit: 'metric'}), 'bottom-left');
      const timeout = setTimeout(() => { if (!loaded) unavailable(); }, 20000);
      map.on('error', event => {
        if (!loaded || !event.sourceId || !['st-terrain', 'st-shade'].includes(event.sourceId)) return;
        is3D = false;
        map.setTerrain(null);
        view.setAttribute('aria-pressed', 'false');
        view.disabled = true;
        fit(0);
        status.textContent = text('Terrain unavailable. You can explore the route in 2D and download the GPX.',
          'Tampilan 3D belum tersedia. Kamu masih bisa melihat peta 2D dan mengunduh file GPX.');
      });
      map.once('load', () => {
        try {
          clearTimeout(timeout);
          map.addSource('st-terrain', {type: 'raster-dem', tiles: ['https://s3.amazonaws.com/elevation-tiles-prod/terrarium/{z}/{x}/{y}.png'],
            tileSize: 256, maxzoom: 15, encoding: 'terrarium', attribution: '<a href="https://registry.opendata.aws/terrain-tiles/" target="_blank" rel="noopener">Terrain Tiles</a>'});
          map.addSource('st-shade', {type: 'raster-dem', tiles: ['https://s3.amazonaws.com/elevation-tiles-prod/terrarium/{z}/{x}/{y}.png'],
            tileSize: 256, maxzoom: 15, encoding: 'terrarium'});
          const firstSymbol = map.getStyle().layers.find(layer => layer.type === 'symbol');
          map.addLayer({id: 'st-hillshade', type: 'hillshade', source: 'st-shade',
            paint: {'hillshade-shadow-color': '#58634b', 'hillshade-highlight-color': '#fff8e9', 'hillshade-exaggeration': 0.35}},
          firstSymbol && firstSymbol.id);
          map.setTerrain({source: 'st-terrain', exaggeration: 1});
          map.addSource('st-loop', {type: 'geojson', data: line});
          map.addSource('st-travelled', {type: 'geojson', data: feature([points[0].slice(0, 2), points[0].slice(0, 2)])});
          map.addLayer({id: 'st-route-halo', type: 'line', source: 'st-loop', layout: {'line-join': 'round', 'line-cap': 'round'},
            paint: {'line-color': '#fff', 'line-width': 7, 'line-opacity': 0.95}});
          map.addLayer({id: 'st-route-line', type: 'line', source: 'st-loop', layout: {'line-join': 'round', 'line-cap': 'round'},
            paint: {'line-color': '#c54c0b', 'line-width': 4}});
          map.addLayer({id: 'st-route-travelled', type: 'line', source: 'st-travelled', layout: {'line-join': 'round', 'line-cap': 'round'},
            paint: {'line-color': '#231f20', 'line-width': 4}});
          const start = document.createElement('div'); start.className = 'st-route-marker';
          start.textContent = text('TOI · Start / finish', 'TOI · Start / finis');
          new gl.Marker({element: start, anchor: 'bottom', offset: [0, -10]}).setLngLat(points[0].slice(0, 2)).addTo(map);
          const marker = document.createElement('div'); marker.className = 'st-route-cursor'; marker.setAttribute('aria-hidden', 'true');
          cursor = new gl.Marker({element: marker}).setLngLat(points[0].slice(0, 2)).addTo(map);
          loaded = true;
          showProgress(progress);
          fit(0);
          root.querySelector('[data-route-fallback]').hidden = true;
          root.querySelector('[data-route-toolbar]').hidden = false;
          status.textContent = text('Explore in 3D, play the loop or move the slider below.', 'Lihat jalur dalam 3D, putar animasi rute, atau geser penanda di bawah peta.');
          map.on('dragstart', pause);
          map.getCanvas().addEventListener('webglcontextlost', unavailable, {once: true});
        } catch (_) { unavailable(); }
      });
    } catch (_) { unavailable(); }
  }
  showProgress(0);
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting)) { observer.disconnect(); loadMap(); }
      else pause();
    }, {rootMargin: '150px'});
    observer.observe(root);
    const playbackObserver = new IntersectionObserver(entries => {
      if (!entries.some(entry => entry.isIntersecting)) pause();
    });
    playbackObserver.observe(root);
  } else loadMap();
})();
